import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
    deleteRegionalProjectRequest: ['response'],
    deleteRegionalProjectSuccess: ['response'],
    deleteRegionalProjectFailure: ['error'],
})

export const deleteRegionalProjectTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
    response: null,
    error: null,
    loading: null,
})

/* ------------- Reducers ------------- */

const deleteRegionalProjectRequest = state => state.merge({ success: null })

const deleteRegionalProjectSuccess = (state, { response }) =>
    state.merge({
        success: true,
        error: false,
        response,
    })

const deleteRegionalProjectFailure = (state, { error }) => {
    const { response } = error
    return state.merge({
        success: false,
        error: true,
        response,
    })
}
export const reducer = createReducer(INITIAL_STATE, {
    [Types.DELETE_REGIONAL_PROJECT_REQUEST]: deleteRegionalProjectRequest,
    [Types.DELETE_REGIONAL_PROJECT_SUCCESS]: deleteRegionalProjectSuccess,
    [Types.DELETE_REGIONAL_PROJECT_FAILURE]: deleteRegionalProjectFailure,
})
